import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';

import { errorRed, successGreen, veryLightGreen, veryLightRed } from '~/styles';

export const FormErrorWrapper = styled(Box)`
  color: ${errorRed};
  margin-top: 10px;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof Box>>>;

export const FormSuccessWrapper = styled(Box)`
  color: ${successGreen};
  margin-top: 10px;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof Box>>>;

export const ZuoraFormErrorWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  background-color: ${veryLightRed};
  color: ${errorRed};
  min-height: 45px;
  margin-top: 10px;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof Box>>>;

export const ZuoraFormSuccessWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: capitalize;
  padding: 5px;
  border-radius: 5px;
  background-color: ${veryLightGreen};
  color: ${successGreen};
  min-height: 45px;
  margin-top: 10px;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof Box>>>;
